import React from "react";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import ModalExamples from "../../components/UiExample/ModalExample";
import PageMeta from "../../components/common/PageMeta";

export default function Modals() {
  return (
    <>
      <PageMeta
        title="React.js Modals Dashboard | TailAdmin - React.js Admin Dashboard Template"
        description="This is React.js Modals  page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Modals" />
      <ModalExamples />
    </>
  );
}
